<template>
  <v-container fluid grid-list-xl>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <v-text-field
              :label="labels.name"
              v-model="usuario.name"
              @click:append="editarUsuario('nombre')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.email"
              v-model="usuario.email"
              @click:append="editarUsuario('correo_electronico')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.password"
              value="••••••••"
              append-icon="edit"
              @click:append="editarUsuario('contraseña')"
              outline
              readonly
            ></v-text-field>

            <v-select
              :label="labels.role"
              v-model="usuario.role"
              :items="usuario.role"
              @click:append="editarUsuario('rol')"
              append-icon="edit"
              outline
              readonly
            ></v-select>

            <v-autocomplete
              :label="labels.campuses_a_cargo"
              v-model="usuario.campuses"
              :items="campuses"
              item-text="nombre"
              item-value="uuid"
              attach
              chips
              multiple
              @click:append="editarUsuario('campuses')"
              append-icon="edit"
              outline
              readonly
            ></v-autocomplete>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      loading: false,
      usuario: null,
      campuses: [],
    }),

    computed: mapGetters({
      
    }),

    mounted() {
      this.getUsuario(this.$route.params.id)
      this.getCampuses()
    },

    methods: {
      getUsuario(id) {
        axios.get(api.path('usuarios.single', { id: id } ))
          .then(res => {
            this.usuario = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCampuses() {
        axios
          .get(api.path('campus'))
          .then(res => {
            this.campuses = res.data.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      editarUsuario(campo) {
        this.$router.push({ name: "usuario-editar", params: { 'campo': campo } })
      }
    }
  }
</script>
